import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import HSAxios from "../HSAxios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

export default function Loginorm() {
  const [phone, setPhone] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);

  const navigate = useNavigate();

  const getOTP = () => {
    setBtnLoading(true);
    let otpUrl = "api/admin/owner/get/otp?number=" + phone;

    HSAxios.post(otpUrl)
      .then((response) => {
        console.log(response);
        if (response.status == 200) {
          navigate("/verifyOtp", { state: { phone: phone } });
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => setBtnLoading(false));
  };

  useEffect(() => {
    const token = Cookies.get("token");

    if (token) {
      navigate("/", {});
    }
  }, []);

  return (
    <div className="container mt-5 d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
      <Card
        className="shadow-lg border-0"
        style={{
          width: "100%",
          maxWidth: "400px",
          borderRadius: "20px",
          boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-5px)";
          e.currentTarget.style.boxShadow = "0 15px 50px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 10px 40px rgba(0,0,0,0.1)";
        }}
      >
        <Card.Body className="p-4">
          <div className="text-center mb-4">
            <img
              className="mt-3"
              src="admin_logo.png"
              style={{ height: "90px", transition: "transform 0.3s ease" }}
              alt="Hostel Logo"
              onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
            />
            <h4 className="mt-3 fw-bold" style={{ color: "#760B0B" }}>Welcome Back</h4>
            <p className="text-muted small">Enter your phone number to continue</p>
          </div>

          <div className="text-start">
            <Form className="mt-3">
              <Form.Group className="mb-3">
                <Form.Label className="text-start fw-semibold mb-2" style={{ color: "#333" }}>
                  Phone Number
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your 10-digit number"
                  onChange={(event) => setPhone(event.target.value)}
                  maxLength="10"
                  className="py-2"
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #e0e0e0",
                    transition: "border-color 0.3s ease",
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#8B0000"}
                  onBlur={(e) => e.target.style.borderColor = "#e0e0e0"}
                />
              </Form.Group>

              <div className="d-grid gap-2 mt-4">
                <Button
                  className="py-2 fw-semibold"
                  style={{
                    backgroundColor: "#8B0000",
                    borderColor: "#8B0000",
                    borderRadius: "10px",
                    fontSize: "16px",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 15px rgba(139, 0, 0, 0.3)",
                  }}
                  type="button"
                  onClick={() => getOTP()}
                  disabled={btnLoading}
                  onMouseEnter={(e) => {
                    if (!btnLoading) {
                      e.target.style.backgroundColor = "#A00000";
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow = "0 6px 20px rgba(139, 0, 0, 0.4)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!btnLoading) {
                      e.target.style.backgroundColor = "#8B0000";
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 4px 15px rgba(139, 0, 0, 0.3)";
                    }
                  }}
                >
                  {btnLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Getting OTP...
                    </>
                  ) : (
                    "Get OTP"
                  )}
                </Button>
              </div>
            </Form>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
